import * as datastore from '@/datastore'

export interface Category extends datastore.Reference {
	color: string
	icon: string
	name: string
}

export const defaultCategory: Readonly<Category> = {
	$id: '',
	color: '',
	icon: 'layers',
	name: '',
}
